<footer>
    <div class="main">
        <div class="container">
            <div class="footer py-5">
                <div class="footer-cta">
                    <div class="footer-cta-text">
                        <span class="footer-cta-badge"><i class="fa-solid fa-headset"></i> Need expert help?</span>
                        <h2>Ready to simplify your business &amp; tax compliance?</h2>
                        <p>Talk to a verified CA or lawyer and get started in minutes — at transparent prices.</p>
                    </div>
                    <a routerLink="/talk-to-advisor" class="footer-cta-btn">
                        Talk to an Expert <i class="fa-solid fa-arrow-right"></i>
                    </a>
                </div>

                <div class="footer-grid">
                    <!-- Brand -->
                    <div class="footer-brand">
                        <a routerLink="/" class="footer-logo" aria-label="LegalStack home">
                            <img src="/assets/icons/header/legalStack.svg"
                                alt="LegalStack — Tax, GST &amp; Business Compliance in India" />
                        </a>
                        <p class="logo_head-subText">Seamless access to legal &amp; financial consultation. Connect with
                            experienced lawyers and finance professionals through call, chat, or video — tax filing,
                            business registration, trademark, and essential compliances, all under one roof.</p>
                        <div class="social">
                            <a href="https://x.com/legalstack" target="_blank" rel="noopener" aria-label="X (Twitter)">
                                <i class="fa-brands fa-x-twitter"></i>
                            </a>
                            <a href="https://www.instagram.com/legalstack.in" target="_blank" rel="noopener"
                                aria-label="Instagram">
                                <i class="fa-brands fa-instagram"></i>
                            </a>
                            <a href="https://www.youtube.com/@thelegalstack" target="_blank" rel="noopener"
                                aria-label="YouTube">
                                <i class="fa-brands fa-youtube"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/legalstack" target="_blank" rel="noopener"
                                aria-label="LinkedIn">
                                <i class="fa-brands fa-linkedin-in"></i>
                            </a>
                        </div>
                    </div>

                    <!-- Business (dynamic) -->
                    <div class="footer-col">
                        <h4 class="head-text">Business</h4>
                        <ul class="list-unstyled">
                            <li *ngFor="let item of businessMenu">
                                <a [routerLink]="item.url">{{ item.name }}</a>
                            </li>
                        </ul>
                    </div>

                    <!-- Compliances (dynamic) -->
                    <div class="footer-col">
                        <h4 class="head-text">Compliances</h4>
                        <ul class="list-unstyled">
                            <li *ngFor="let item of complianceMenu">
                                <a [routerLink]="item.url">{{ item.name }}</a>
                            </li>
                        </ul>
                    </div>

                    <!-- Company -->
                    <div class="footer-col">
                        <h4 class="head-text">Company</h4>
                        <ul class="list-unstyled">
                            <li><a routerLink="/about-us">About Us</a></li>
                            <li><a routerLink="/contact-us">Contact Us</a></li>
                            <li><a routerLink="/faq">FAQ’s</a></li>
                            <li><a routerLink="/privacy">Privacy Policy</a></li>
                            <li><a routerLink="/terms">Terms &amp; Conditions</a></li>
                            <li><a routerLink="/pricing-return-policy">Pricing &amp; Refund</a></li>
                            <li><a routerLink="/shipping-policy">Shipping Policy</a></li>
                            <li><a routerLink="/become-an-advisor">Become an Advisor</a></li>
                            <li *ngIf="!gS.isUserLoggedin">
                                <a href="javascript:void(0)" (click)="openLoginPopup('login')">Login to LegalStack</a>
                            </li>
                        </ul>
                    </div>

                </div>

                <div class="footer-seo">
                    <h2>India’s Trusted Platform for Tax, GST &amp; Business Compliance</h2>
                    <p>LegalStack helps startups, small businesses, and individuals across India handle legal and
                        financial compliance with confidence. File your <strong>Income Tax Return (ITR)</strong> and
                        <strong>GST returns</strong> online, register a <strong>Private Limited Company</strong>,
                        <strong>LLP</strong>, One Person Company, or Sole Proprietorship, and stay compliant with MSME,
                        PF, ESIC, and TDS — all handled by verified Chartered Accountants and lawyers. From
                        <strong>trademark and copyright protection</strong> to rent agreements and tax-saving
                        consultations, get expert guidance at transparent prices with fast turnaround. Join
                        <strong>1,00,000+ happy clients</strong> who trust LegalStack for hassle-free business
                        registration, tax filing, and legal compliance services in India.</p>

                    <div class="seo-tags">
                        <a routerLink="/products/startup/GST-Registration">GST Registration</a>
                        <a routerLink="/products/tax-and-compliance">ITR Filing</a>
                        <a routerLink="/products/startup/Private-limited-company">Company Registration</a>
                        <a routerLink="/products/startup/MSME-Registration">MSME Registration</a>
                        <a routerLink="/products/gst-filing">GST Filing</a>
                        <a routerLink="/products/agreement/Rent-Agreement">Rent Agreement</a>
                        <a routerLink="/talk-to-advisor">Talk to a CA</a>
                    </div>
                </div>

                <div class="footer-app-bar">
                    <div class="footer-app-bar-text">
                        <h4>Get the App</h4>
                        <p>Manage your tax &amp; compliance on the go — file, track, and consult anytime.</p>
                    </div>
                    <div class="app-buttons">
                        <a class="app-badge"
                            href="https://play.google.com/store/apps/details?id=com.user.legalstack&hl=en_IN"
                            target="_blank" rel="noopener" aria-label="Get it on Google Play">
                            <i class="fa-brands fa-google-play"></i>
                            <span class="app-badge-text"><small>GET IT ON</small><strong>Google Play</strong></span>
                        </a>
                        <button class="app-badge" #appStoreBtn type="button" (click)="openModal()"
                            aria-label="Download on the App Store">
                            <i class="fa-brands fa-apple"></i>
                            <span class="app-badge-text"><small>Download on the</small><strong>App Store</strong></span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="copyright">
                <div class="container py-3">
                    <div class="copyright_box">
                        <div class="col-lg-5 copyright_box__opt">
                            <a routerLink="/become-an-advisor">Become a Partner</a>
                            <a routerLink="/privacy">Privacy</a>
                            <a routerLink="/terms">Terms of use</a>
                        </div>
                        <div class="copyright_box__text">
                            <p class="mb-1">©2026 LegitStack Ventures Pvt. Ltd. All Rights Reserved</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</footer>


<!-- modal -->

<div class="custom-overlay" *ngIf="isOpen" (click)="closeModal()"></div>
<div class="custom-modal coming-soon-modal" *ngIf="isOpen">
    <button class="close-btn" (click)="closeModal()" aria-label="Close">
        <i class="fa-solid fa-xmark"></i>
    </button>

    <div class="cs-body">
        <div class="cs-icon">
            <i class="fa-brands fa-apple"></i>
            <span class="cs-pulse"></span>
        </div>

        <span class="cs-tag">Launching Soon</span>
        <h3 class="cs-title">Our iOS App is Coming Soon</h3>
        <p class="cs-text">We’re putting the finishing touches on the LegalStack iOS app. It’ll be live on the App
            Store very soon — stay tuned!</p>

        <p class="cs-sub">Meanwhile, get it on Android or use the web app.</p>

        <a class="cs-btn"
            href="https://play.google.com/store/apps/details?id=com.user.legalstack&hl=en_IN"
            target="_blank" rel="noopener">
            <i class="fa-brands fa-google-play"></i> Get it on Google Play
        </a>
    </div>
</div>

<app-login *ngIf="isLoginPopup" (close)="closeLoginPopup()" [loginPopuptype]="loginPopuptype"></app-login>
